import React from "react";
import WelcomeBox from "../WelcomeBox";
import ContainerOne from "./ContainerOne";
import ContainerStepOne from "./ContainerStepOne";
import Header from '../common/Header'

function MainContainer() {
  return (
    <>
    <Header/>
        <section className="section2" id="" data-section="section1">
            <div className="container">
                <div className="caption">
                <WelcomeBox/>

                    <div className="btm-form">
                        <ContainerOne/>
                        <div className="progress-wrap">
                            <div className="line-progress-bar">
                                <div className="line"></div>
                                <ul className="checkout-bar">
                                    <li key="1" className="progressbar-dots active"><span>Prepare</span></li>
                                    <li key="2" className="progressbar-dots"><span>Approve</span></li>
                                    <li key="3"className="progressbar-dots"><span>Multidrop</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-12 m-auto">
                                <form action="" id="booking-form">
                                    <div className="tab-content">
                                        <ContainerStepOne/>
                                    </div>
                                    {/* <div id="loader" style={{display:"none",textAalign:"center"}}>
                                        <img alt="" src="//d2erq0e4xljvr7.cloudfront.net/assets/img/ring.svg" style={{width:"50px",margin: "auto"}}/>
                                    </div> */}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default MainContainer;
